export const apiConstantsURL = {
  account: {
    loginAccount: `/loginService/v1/authenticateSuperAdmin`,
    registerAccount: `/loginService/v1/users/createUsers`,
    verifyOtp: `/loginService/v1/verifyOTP`,
    resetPassword: `/loginService/v1/resetPassword`,
    resetPasswordById: `/loginService/v1/resetPassword?userId=`,
    resendOtp: `/loginService/v1/resendOTP`,
    saveUserProfile: `/loginService/v1/users/saveProfile`,
    saveProfileById: `/loginService/v1/users/saveProfile?userId=`,
    getUser: `/loginService/v1/users/getUserById`,
    getUserByManager: `/loginService/v1/users/getUserByManager`,
    getManagerByOrgId: `/loginService/v1/users/getManagerByOrgId`,
    getUserByOrg: `/loginService/v1/users/getUserByOrg`,
    getUserByOrgId: `/loginService/v1/users/getUserByOrg?orgId=`,
    getAllRoles: `/loginService/v1/users/getAllRoles`,
    assignManagerToUser: `/loginService/v1/users/assignManagerToUser?userId=`,
    getUserByPagination: `/loginService/v1/users/getAllUsers?pageNumber=`,
    getNonUserGoalShares: `/loginService/v1/users/getNonUserGoalShares`,
    saveSetting: `/loginService/v1/users/saveSetting`,
    getSetting: `/loginService/v1/users/getSetting`,
  },
  settings: {
    saveFeedback: `/loginService/v1/users/saveFeedback?feedback=`,
    saveContact: `/loginService/v1/users/saveContact?contact=`,
  },
  strength: {
    getStrength: `/commonMasterService/v1/commonMaster/getSuperAdminData?name=Strength`,
    getAllStrength: `/strengthWeakness/v1/getStrength?step=6&userId=`,
    saveStrength: `/strengthWeakness/v1/saveStrength`,
    getUserByManagerActivityPercentage: `/strengthWeakness/v1/getModuleCompletion?userId=`,
    getUserActivityPercentage: `/strengthWeakness/v1/getModuleCompletion`,
  },
  addMoreValue: {
    addMore: `/strengthWeakness/v1/addCommonMasterVal`,
  },
  weakness: {
    getWeakness: `/commonMasterService/v1/commonMaster/getSuperAdminData?name=Weakness`,
    getAllWeakness: `/strengthWeakness/v1/getWeakness?step=6&userId=`,
    saveWeakness: `/strengthWeakness/v1/saveWeakness`,
  },
  personalValues: {
    getPersonalValues: `/commonMasterService/v1/commonMaster/getSuperAdminData?name=PersonalValue`,
    getAllPersonalValues: `/strengthWeakness/v1/getPersonalValue?step=6&userId=`,
    savePersonalValue: `/strengthWeakness/v1/savePersonalValue`,
  },
  motivatesYou: {
    getMotivatesYou: `/commonMasterService/v1/commonMaster/getSuperAdminData?name=Motivation`,
    getTheirMotivates: `/strengthWeakness/v1/getWhatMotivatesYou?userId=`,
    getWhatMotivatesYouConstant: `/strengthWeakness/v1/getWhatMotivatesYouConstant`,
    saveMotivatesYou: `/strengthWeakness/v1/saveWhatMotivatesYou`,
    updateCommmonMasterValue: `/commonMasterService/v1/commonMaster/updateSuperAdminData`,
  },
  goals: {
    getAllStickCard: `/strengthWeakness/v1/getGoal?goal=`,
    saveGoal: `/strengthWeakness/v1/updateGoal`,
    addGoal: `/strengthWeakness/v1/addGoal`,
    isShared: '/strengthWeakness/v1/acceptRejectGoal?isShared=true&goal=0',
    acceptOrDecline:
      '/strengthWeakness/v1/acceptRejectGoal?isAccept=true?goalId=2',
  },
  DICSProfiling: {
    getDISCQuestions: `/discService/v1/disc/getDiscQuestion/`,
    getAllDiscQuestion: `/discService/v1/disc/getAllDiscQuestion`,
    getGraphValues: `/discService/v1/disc/generateDiscGraph`,
    getGraphValuesForManager: `/discService/v1/disc/generateDiscGraph?userId=`,
    saveDISCQuestions: `/discService/v1/disc/saveDisc`,
    updateDISCQuestion: `/discService/v1/disc/updateDiskQuestion`,
  },
  activity: {
    deleteActivityItem: `/commonMasterService/v1/commonMaster/deleteSuperAdminData?valueId=`,
  },
  observations: {
    saveObservation: `/loginService/v1/users/saveObservation`,
    getAllObservations: `/loginService/v1/users/getAllObservation/`,
    deleteObservationById: `/loginService/v1/users/deleteObservationById/`,
  },
  organization: {
    saveOrganization: `/organizationService/v1/organization/saveOrganization`,
    creteTeamAndGroup: `/loginService/v1/users/saveTeam`,
    updateTeamAndGroup: `/loginService/v1/users/update/`,
    deleteTeamAndGroup: `/loginService/v1/users/delete/`,
    getAllTeams: `/loginService/v1/users/getAllTeams`,
    deleteUser: `/loginService/v1/users/deleteUser/`,
    getDashboardSummary: `/loginService/v1/users/getDashboardSummary`,
    getAllOrganisation: `/organizationService/v1/organization/getOrganization`,
    getInvoiceByOrgId: `/organizationService/v1/organization/getOrganizationLicense?orgId=`,
  },
  uploads: {
    uploadImage: `/loginService/v1/users/upload?code=UPLOAD`,
  },
  stripe: {
    createPaymentIntent: '/paymentService/v1/payment/createIntent',
  },
  usageReporting: {
    getUserLevels: `/loginService/v1/users/getUserLevels?teamName=`,
  },

  licences: {
    getLicenses: `/organizationService/v1/organization/getLicenses`,
    assignLicenseToUser: `/organizationService/v1/organization/assignLicenseToUser?userId=`,
    generateLicenses: `/organizationService/v1/organization/generateLicenses?isMonth=`,
    getAllInvoicesByOrgId: `/organizationService/v1/organization/getAllInvoices?orgId=`,
  },
  countryDetails: {
    getAllCountry: `https://countriesnow.space/api/v0.1/countries`,
    getStatesOfCountry: `https://countriesnow.space/api/v0.1/countries/states`,
  },
  visionBoard: {
    getVisionType: `/visionService/v1/vision/getVisionType`,
    createVisionBoard: `/visionService/v1/vision/saveVision`,
    deleteVisionBoard: `/visionService/v1/vision/deleteVision/`,
    getAllVisionBoards: `/visionService/v1/vision/getAllVisions`,
    getVisionBoardById: `/visionService/v1/vision/getVisionById/`,
    updateVisionBoardById: `/visionService/v1/vision/updateVision/`,
    mergeVisionBoard: `/visionService/v1/vision/saveMergeVision`,
    uploadImage: `/loginService/v1/users/upload?code=UPLOAD`,
    uploadImageVision: `/loginService/v1/users/upload?code=VISION`,
    getAllImages: `/loginService/v1/users/getImagesByUserId?code=VISION`,
    getAllImagesByVision: `/loginService/v1/users/getImagesByUserId?code=VISION`,
    getVesionBoardByUserId: `/visionService/v1/vision/getAllVisions?userId=`,
    pinVisionBoard: `/visionService/v1/vision/pinVision/`,
  },
};
